// removed by extract-text-webpack-plugin
module.exports = {"icons":"_3TMltOYdsnhTDc8DFE5Y0I"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/Search/Customer/style.css
// module id = 2455
// module chunks = 0